/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUnitsForMerchant} from '../api'

 export const useQueryGetUnitsForMerchant = createReactQueryHook('getUnitsForMerchant', getUnitsForMerchant)
